/* ============================================================
   AŞKIM: product photographs
   One photograph at a time. Phones swipe (the strip is a scroll-snap
   row, so swiping works even before this script runs); computers get
   arrows; the keyboard's left and right arrows step through; the dots
   underneath show where you are and jump on a tap. Nothing moves on its
   own. product.js calls refresh() after a colour change, which rebuilds
   the dots for that colour's photos and goes back to the first.
   Loaded as a plain script in the browser (window.AskimGallery) and as a
   module by the tests, which exercise slideIndex and stepIndex.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.AskimGallery = api; api.refresh(); }
})(this, function () {

  /* Which photo is in view, from how far the strip has scrolled. */
  function slideIndex(scrollLeft, slideWidth, count) {
    if (!count || !slideWidth) return 0;
    return Math.min(count - 1, Math.max(0, Math.round(scrollLeft / slideWidth)));
  }

  /* One photo on, or back, wrapping round at the ends. */
  function stepIndex(index, delta, count) {
    if (!count) return 0;
    return ((index + delta) % count + count) % count;
  }

  var el = null;

  function slides() {
    return [].slice.call(el.track.querySelectorAll('.figure[data-media-id]:not([hidden])'));
  }

  function current() {
    return slideIndex(el.track.scrollLeft, el.track.clientWidth, slides().length);
  }

  /* The photo an arrow, key or dot is gliding to. A quick second click
     counts on from there, not from wherever the glide has got to. */
  var heading = null;
  function from() { return heading !== null ? heading : current(); }

  function go(index, instant) {
    var calm = instant || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var there = Math.abs(el.track.scrollLeft - index * el.track.clientWidth) < 2;
    /* Already there, no glide follows to clear it, so set nothing. */
    heading = calm || there ? null : index;
    el.track.scrollTo({ left: index * el.track.clientWidth, behavior: calm ? 'auto' : 'smooth' });
  }

  /* Dots, the Tab order (only the photo on show can be reached, so Tab goes
     on to the arrows and dots), and the next photo loading ahead of a swipe. */
  function paint() {
    var i = current();
    [].forEach.call(el.dots.children, function (d, n) {
      if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    slides().forEach(function (f, n) {
      f.tabIndex = n === i ? 0 : -1;
      var img = f.querySelector('img');
      if (img && Math.abs(n - i) === 1) img.loading = 'eager';
    });
  }

  function bind(gallery) {
    el = {
      gallery: gallery,
      track: gallery.querySelector('[data-track]'),
      dots: gallery.querySelector('[data-dots]'),
      prev: gallery.querySelector('.pdp__nav--prev'),
      next: gallery.querySelector('.pdp__nav--next')
    };
    var queued = false;
    el.track.addEventListener('scroll', function () {
      if (heading !== null && Math.abs(el.track.scrollLeft - heading * el.track.clientWidth) < 2) heading = null;
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paint(); });
    }, { passive: true });
    /* A finger or trackpad takes over from any glide under way, and so does
       focus landing on some other photo. */
    ['touchstart', 'wheel'].forEach(function (t) {
      el.track.addEventListener(t, function () { heading = null; }, { passive: true });
    });
    el.track.addEventListener('focusin', function (e) {
      if (slides().indexOf(e.target) !== heading) heading = null;
    });
    el.prev.addEventListener('click', function () { go(stepIndex(from(), -1, slides().length)); });
    el.next.addEventListener('click', function () { go(stepIndex(from(), 1, slides().length)); });
    /* Left and right on a photo move to the next one and take focus with
       them, so Enter opens the photo on show. */
    el.track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var to = stepIndex(from(), e.key === 'ArrowRight' ? 1 : -1, slides().length);
      go(to);
      var f = slides()[to];
      if (f && e.target !== el.track) f.focus({ preventScroll: true });
    });
    el.dots.addEventListener('click', function (e) {
      var d = e.target.closest('[data-dot]');
      if (d) go(+d.getAttribute('data-dot'));
    });
    /* The strip changes width with the window; keep the same photo in view.
       iPhones fire resize when the toolbar hides, with the width unchanged:
       ignore that, or it would cut a swipe short. */
    var keep = 0, width = el.track.clientWidth;
    window.addEventListener('resize', function () {
      if (el.track.clientWidth === width) return;
      width = el.track.clientWidth;
      go(keep, true);
    }, { passive: true });
    el.track.addEventListener('scroll', function () { keep = current(); }, { passive: true });
  }

  /* Build the dots for the photos on show and go back to the first. */
  function refresh() {
    if (typeof document === 'undefined') return;
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || !gallery.querySelector('[data-track]')) return;
    if (!el || el.gallery !== gallery) bind(gallery);
    var shown = slides(), count = shown.length;
    el.dots.innerHTML = '';
    shown.forEach(function (f, n) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'pdp__dot';
      d.setAttribute('data-dot', n);
      d.setAttribute('aria-label', 'Photo ' + (n + 1) + ' of ' + count);
      el.dots.appendChild(d);
      var img = f.querySelector('img');
      f.setAttribute('aria-label', 'View larger, photo ' + (n + 1) + ' of ' + count + (img && img.alt ? ': ' + img.alt : ''));
    });
    var single = count < 2;
    el.dots.hidden = single; el.prev.hidden = single; el.next.hidden = single;
    go(0, true);
    paint();
  }

  return { slideIndex: slideIndex, stepIndex: stepIndex, refresh: refresh };
});
